import { render, staticRenderFns } from "./ListaFaq.vue?vue&type=template&id=09a73126&"
import script from "./ListaFaq.vue?vue&type=script&lang=js&"
export * from "./ListaFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports